import { type ISbStoryData } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { type CmsAlternateUrlsMetadata } from '../../model/storyAccessors/CmsAlternateUrlsMetadata'
import { storyAccessorHasNoIndexInSeoRobots } from '../../model/storyAccessors/storyAccessorHasNoIndexInSeoRobots'
import { type ContentType } from '../../storyblok'

type CmsSeoHrefLangsProps = {
  hrefLangs: CmsAlternateUrlsMetadata[]
  story: ISbStoryData<ContentType>
}

export const CmsSeoHrefLangs: FC<CmsSeoHrefLangsProps> = ({
  hrefLangs,
  story,
}) => {
  if (storyAccessorHasNoIndexInSeoRobots(story)) {
    return null
  }

  return (
    <>
      {hrefLangs.map((item) => (
        <link
          href={item.href}
          hrefLang={item.hrefLang}
          key={item.href}
          rel="alternate"
        />
      ))}
    </>
  )
}
